import React from 'react';

const Shipping = () => {
  return (
    <div>
      <h2>Shipping</h2>
      <p>Manage shipments, delivery status, and logistics.</p>
    </div>
  );
};

export default Shipping;
